import { render, staticRenderFns } from "./TipoDocumentoListagem.vue?vue&type=template&id=1a8b1fbc&scoped=true"
import script from "./TipoDocumentoListagem.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b1fbc",
  null
  
)

export default component.exports